export default __webpack_public_path__ + "static/media/puree_salmon.262660e8.jpg";